var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.818,
    height: 19,
    viewBox: "0 0 13.818 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-ios-share",
    "data-name": "Icon material-ios-share",
    d: "M16.364,4.955,15.137,6.181,13.764,4.808v9.647h-1.71V4.808L10.681,6.181,9.455,4.955,12.909,1.5Zm3.455,4.318v9.5A1.732,1.732,0,0,1,18.091,20.5H7.727A1.727,1.727,0,0,1,6,18.773v-9.5A1.721,1.721,0,0,1,7.727,7.545h2.591V9.273H7.727v9.5H18.091v-9.5H15.5V7.545h2.591A1.727,1.727,0,0,1,19.818,9.273Z",
    transform: "translate(-6 -1.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.8801bc7801e517ac9c1deb4c096ae528.svg";
export { ForwardRef as ReactComponent };